{
  "general": {
    "loginFailed": "Deine Logindaten waren falsch. Bitte versuche es erneut.",
    "refreshTokenExpired": "Du bist aus Sicherheitsgründen ausgeloggt worden. Bitte logge dich erneut ein.",
    "open": "Öffnen",
    "error": "Fehler",
    "cancel": "Abbrechen",
    "close": "Schliessen",
    "save": "Speichern"
  },
  "validationErrors": {
    "genericError": "Dieser Wert kann nicht gespeichert werden."
  },
  "schema": {
    "transactions": "Transaktionen",
    "accounts": "Konten",
    "projects": "Projekte",
    "reports": "Reports",
    "blog": "Blog",
    "pleaseEnterValue": "Bitte gib einen neuen Wert für dieses Attribut ein.",
    "transactionTypes": {
      "sale": "Kauf",
      "purchase": "Verkauf",
      "split": "Split"
    },
    "deposits": {
      "transaction": {
        "ownName": "Transaktion",
        "date": {
          "label": "Datum",
          "description": "Transaktionsdatum."
        },
        "otherParty": {
          "label": "Transaktionspartei",
          "description": "Sender oder Empfänger der Transaktion."
        },
        "otherPartyAccount": {
          "label": "Kontonummer",
          "description": "IBAN (Kontonr.) des Senders oder Empfängers der Transaktion."
        },
        "description": {
          "label": "Beschreibung",
          "description": "Transaktionsbeschreibung."
        },
        "amount": {
          "label": "Betrag",
          "description": "Betrag dieser Transaktion in deiner Basiswährung."
        },
        "accountCurrencyAmount": {
          "label": "Betrag",
          "description": "Betrag dieser Transaktion in der Währung dieses Kontos."
        },
        "currency": {
          "label": "Kontowährung",
          "description": "Die Währung, in der dieses Konto geführt wird."
        },
        "fxAmount": {
          "label": "Fremdwährungsbetrag",
          "description": "Optional. Wenn die Transaktion ursprünglich in einer Fremdwährung erfolgt ist, dann der Fremdwährungsbetrag gehört hierhin."
        },
        "fxCurrency": {
          "label": "Fremdwährungs-Code",
          "description": "Optional. Wenn die Transaktion ursprünglich in einer Fremdwährung erfolgt ist, dann hier gehört das 3-stellige Währungssymbol."
        },
        "simulated": {
          "label": "Simulierte Transaktion",
          "description": "Ein Zeichen in dieser Spalte bedeutet, dass dies eine fiktive (simulierte) Transaktion ist, die in der Zukunft stattfindet."
        },
        "incomeFromInterest": {
          "label": "Kapitaleinkommen",
          "description": "Ein Etikett in dieser Spalte bedeutet, dass die Transaktion zu Kapitaleinkommen gehört."
        }
      },
      "account": {
        "ownName": "Bankkonto",
        "name": "Bankname",
        "country": "Land",
        "accountName": {
          "label": "Kontoname",
          "tooltip": "Unter welchem Namen möchtest du dieses Konto im System sehen?",
          "error": "Bitte gebe eine Bezeichnung für dieses Konto ein."
        },
        "baseCurrency": {
          "label": "Basiswährung",
          "tooltip": "Welche Währung möchtest du als Basiswährung verwenden? In der Regel ist dies die Währung, in der du verdienst."
        },
        "iban": {
          "label": "IBAN",
          "tooltip": "Die IBAN-Nummer dieses Kontos. Beginnt mit einem Land-Kürzel z.B. >DE< für Deutschland.",
          "placeholder": "DE12345678901234567890"
        },
        "bic": {
          "label": "BIC",
          "tooltip": "Internationaler Bankcode (genannt >BIC<) für die Bank, bei der dieses Konto geführt wird. Bis zu 11 Zeichen lang. Dient zur Identifikation einer Bank im internationalen Kontext."
        },
        "bankName": {
          "label": "Bankname",
          "tooltip": "Name der Bank, bei der dieses Konto geführt wird.",
          "placeholder": "Sparkasse Bielefeld"
        },
        "syncType": {
          "label": "Synchronisation",
          "tooltip": "Wie sollen die Daten für dieses Konto synchronisiert werden?",
          "placeholder": "Wähle eine Option"
        },
        "depositType": {
          "label": "Kontoart",
          "tooltip": "Tagesgeld oder Girokonto?",
          "placeholder": "Wähle eine Option"
        },
        "countryCode": {
          "label": "Land",
          "tooltip": "In welchem Land befindet sich dieses Konto?",
          "placeholder": "Wähle ein Land"
        },
        "category": {
          "label": "Kategorie",
          "tooltip": "Welcher Anlagekategorie gehört dieses Konto an?",
          "placeholder": "Wähle eine Option"
        },
        "parameters": {
          "syncType": {
            "manual": "Manuell",
            "automatic": "Automatisch"
          },
          "depositType": {
            "savings-account": "Giro",
            "time-deposit": "Fest- / Tagesgeld"
          }
        }
      }
    },
    "stocks": {
      "transaction": {
        "date": {
          "label": "Datum",
          "description": "Datum der Transaktion."
        },
        "displaySymbol": {
          "label": "Wertpapiersymbol*",
          "description": "Symbol des gehandelten Wertpapiers, wie ISIN, WKN oder CUSIP. Optionalfeld."
        },
        "displayName": {
          "label": "Wertpapiername",
          "description": "Name des Aktienwertpapiers."
        },
        "transactionAmount": {
          "label": "Menge",
          "description": "Anzahl der gekauften oder verkauften Wertpapiere."
        },
        "transactionPrice": {
          "label": "Preis (Basiswährung)",
          "description": "Einheitspreis, bezahlt in Ihrer Basiswährung."
        },
        "transactionCurrency": {
          "label": "Währung",
          "description": "Währung der Transaktion."
        },
        "transactionOriginalPrice": {
          "label": "Preis (Transaktionswährung)",
          "description": "Einheitspreis, bezahlt in Transaktionswährung."
        }
      },
      "account": {
        "brokerName": {
          "label": "Brokername",
          "tooltip": "Bei welchem Broker ist dieses Konto?",
          "placeholder": "DepotX"
        },
        "isImported": {
          "label": "Dieses Konto wird erstellt.",
          "tooltip": "Entferne das Häkchen, um zu verhindern, dass dieses Konto erstellt wird."
        },
        "accountNo": {
          "label": "Depotnummer",
          "tooltip": "Welche Nummer trägt dein Depot?",
          "placeholder": "C12345678"
        },
        "username": {
          "label": "Username",
          "tooltip": "Wie lautet dein Username bei diesem Broker?",
          "placeholder": "user01"
        },
        "syncType": {
          "label": "Synchronisierung",
          "tooltip": "Wie sollen die Daten für dieses Konto synchronisiert werden?",
          "placeholder": "Wähle eine Option"
        },
        "ownCurrentAccount": {
          "label": "Verknüpftes Girokonto (IBAN)",
          "tooltip": "Welches Girokonto ist mit diesem Depot verknüpft?",
          "placeholder": "DE12345678901234567890"
        },
        "countryCode": {
          "label": "Land",
          "tooltip": "In welchem Land befindet sich dieses Konto?",
          "placeholder": "Wähle ein Land"
        },
        "connectedDepositAccounts": {
          "label": "Verlinkte Bankkonten",
          "tooltip": "Auf welche Bankkonten fließen Erlöse aus diesem Konto?"
        }
      }
    },
    "meta-comment": "the entries below are realEstate quotes, but this is only used in import of quotes, so leaving it be for now",
    "realEstate": {
      "transaction": {
        "date": {
          "label": "Datum",
          "description": "Datum der Bewertung."
        },
        "currency": {
          "label": "Währung",
          "description": "Die Währung der Bewertung."
        },
        "quote": {
          "label": "Preis",
          "description": "Bewertung in dieser Währung."
        },
        "quoteBaseCurrency": {
          "label": "Preis (Basiswährung)",
          "description": "Bewertung in Ihrer Basiswährung."
        }
      },
      "account": {
        "kindOfProperty": "Um was für eine Immobilie handelt es sich?",
        "connectedDepositAccounts": {
          "label": "Verlinkte Bankkonten",
          "tooltip": "Auf welche Bankkonten fließen Erlöse aus diesem Konto?"
        },
        "valuationParameters": {
          "type": {
            "label": "Haus oder Wohnung"
          },
          "subtype": {
            "label": "Art der Immobilie",
            "description": "Was für Haus / Wohnung ist es?",
            "tooltip": "Welche Art von Gebäude / Wohnung ist das hier?"
          },
          "streetAddress": {
            "label": "Straße und Nummer",
            "tooltip": "Wo befindet sich deine Immobilie?",
            "placeholder": "Hochstr. 12"
          },
          "zip": {
            "label": "Postleitzahl",
            "tooltip": "Welche Postleitzahl hat deine Immobilie?",
            "placeholder": "33602",
            "error": "Bitte trage eine Postleitzahl ein."
          },
          "district": {
            "label": "Ort / Stadtteil",
            "tooltip": "Für Immobilien in Stadtkreisen verwende bitte hier den Stadtteil. Für Immobilien in Landkreisen verwende bitte hier den Ort (ggf. Kernstadt) und KEINEN Stadtteil.",
            "placeholder": "Mitte"
          },
          "city": {
            "label": "Stadtkreis / Landkreis",
            "tooltip": "In welchem Stadt- oder Landkreis befindet sich deine Immobilie?",
            "placeholder": "Bielefeld",
            "error": "Bitte trage einen Stadtkreis oder Landkreis ein."
          },
          "countryCode": {
            "label": "Land",
            "tooltip": "In welchem Land befindet sich deine Immobilie?",
            "placeholder": "Deutschland",
            "error": "Bitte trage ein Land ein."
          },
          "completeArea": {
            "label": "Nutzfläche",
            "tooltip": "Wie groß ist deine gesamte Immobilie (in m²)?",
            "placeholder": "100"
          },
          "livingArea": {
            "label": "Wohnfläche",
            "tooltip": "Wie groß ist die Wohnfläche der Immobilie (in m²)?",
            "placeholder": "88",
            "error": "Bitte trage die Wohnfläche ein."
          },
          "floor": {
            "label": "Etage",
            "tooltip": "In welcher Etage liegt die Immobilie?",
            "placeholder": "3"
          },
          "totalFloors": {
            "label": "Anzahl Stockwerke",
            "tooltip": "Wie viele Stockwerke hat das Gebäude insgesamt?",
            "placeholder": "4"
          },
          "rooms": {
            "label": "Zimmer",
            "tooltip": "Wie viele Zimmer hat deine Immobilie?",
            "placeholder": "3"
          },
          "flooring": {
            "label": "Fußboden",
            "tooltip": "Welche Art von Fußboden hat deine Immobilie?"
          },
          "interiorLevel": {
            "label": "Ausstattungsniveau",
            "tooltip": "Wie hochwertig ist die Ausstattung deiner Immobilie?"
          },
          "condition": {
            "label": "Zustand",
            "tooltip": "Wie ist der aktueller Zustand deiner Immobilie zu bewerten?"
          },
          "lotArea": {
            "label": "Grundstücksfläche",
            "tooltip": "Wie groß ist das Grundstück, auf dem sich deine Immobilie befindet (in Quadratmetern)?",
            "placeholder": "450"
          },
          "constructionYear": {
            "label": "Baujahr",
            "tooltip": "Wann wurde deine Immobilie gebaut?",
            "placeholder": "2010"
          },
          "energyClass": {
            "label": "Energieverbrauch",
            "tooltip": "Jährlicher Energieverbrauch in kWh/m². Wenn dir nur die Energieeffizienzklasse vorliegt, trage den Durchschnittwert für diese Klasse ein.",
            "placeholder": 60
          },
          "heatingType": {
            "label": "Heizung",
            "tooltip": "Welche Art von Heizung hat deine Immobilie?"
          },
          "floorHeating": {
            "label": "Fußbodenheizung?",
            "tooltip": "Ist Fußbodenheizung vorhanden?"
          },
          "lastRenovationYear": {
            "label": "Letzte Renovierung",
            "tooltip": "Wann wurde deine Immobilie zuletzt renoviert?",
            "placeholder": "2020"
          },
          "privateParkingSpaces": {
            "label": "Stellplätze",
            "tooltip": "Wie viele reservierte Stellplätze gibt es für deine Immobilie?",
            "placeholder": 1
          },
          "garden": {
            "label": "Garten?",
            "tooltip": "Hat deine Immobilie einen Garten?"
          },
          "bathTub": {
            "label": "Badewanne?",
            "tooltip": "Gibt es in der Immobilie eine Badewanne?"
          },
          "bathWithWindows": {
            "label": "Tageslichtbad",
            "tooltip": "Gibt es in der Immobilie ein Bad mit Fenster?"
          },
          "fullHeightWindows": {
            "label": "Bodentiefe Fenster?",
            "tooltip": "Gibt es in der Immobilie bodentiefe Fenster?"
          }
        },
        "parameters": {
          "meta-comment": "these are also used in Real Estate API - change them there as well if changing them here",
          "type": {
            "apartment": "Wohnung",
            "building": "Gebäude"
          },
          "subtype": {
            "building": {
              "farm": "Bauernhof",
              "special-building": "Sondergebäude",
              "bungalow": "Bungalow",
              "castle": "Schloss",
              "semi-detached": "Doppelhaushälfte",
              "detached": "Einfamilienhaus",
              "apartment-building": "Mehrfamilienhaus",
              "terraced": "Reihenhaus",
              "terraced-corner": "Eckreihenhaus",
              "villa": "Villa",
              "other": "Andere"
            },
            "apartment": {
              "top-floor": "Dachgeschoss",
              "ground-floor": "Erdgeschoss",
              "other-floor": "Anderes Geschoss",
              "high-ground-floor": "Hochparterre",
              "loft": "Loft",
              "two-levels": "Maisonette",
              "penthouse": "Penthouse",
              "souterrain": "Souterrain",
              "with-balcony": "Terrassenwohnung",
              "other": "Andere"
            }
          },
          "interiorLevel": {
            "simple": "Einfach",
            "normal": "Normal",
            "high": "Gehoben",
            "luxus": "Luxus"
          },
          "condition": {
            "new": "Erstbezug",
            "newly-renovated": "Erstbezug nach Sanierung",
            "well-maintained": "Gepflegt",
            "modernized": "Modernisiert",
            "flexible": "Nach Vereinbarung",
            "like-new": "Neuwertig",
            "needs-renovation": "Renovierungsbedürftig",
            "refurbished": "Saniert",
            "completely-renovated": "Vollständig renoviert",
            "needs-repair": "Abbruchreif"
          },
          "heatingType": {
            "gas": "Gas",
            "oil": "Öl",
            "electricity": "Elektrisch",
            "district": "Fernwärme",
            "wood": "Holz",
            "coal": "Kohle",
            "solar": "Solar",
            "block": "Blockheizung",
            "stock": "Stockheizung",
            "floor": "Fußbodenheizung",
            "nachtspeicher": "Nachtspeicherheizung",
            "wärmekraft": "Wärmekraft",
            "central": "Zentral"
          },
          "flooring": {
            "carpet": "Teppich",
            "parquet": "Parkett",
            "tiles": "Fliesen",
            "laminate": "Laminat",
            "floorboards": "Dielen"
          }
        }
      },
      "quote": {
        "label": "Preis",
        "description": "Bewertung in dieser Währung."
      },
      "quoteBaseCurrency": {
        "label": "Preis (Basiswährung)",
        "description": "Bewertung in deiner Basiswährung."
      },
      "note": {
        "label": "Notiz",
        "description": "Optional. Alle Bewertungsdetails, die du möglicherweise aufzeichnen möchtest."
      }
    },
    "loans": {
      "account": {
        "parameters": {
          "type": {
            "annuity": "Feste Rate (Annuität)",
            "fixedPrincipal": "Variable Rate (fester Kapitalrückzahlungsbetrag)",
            "interestOnly": "Nur Zinsen"
          },
          "period": {
            "month": "Monatlich",
            "quarter": "Vierteljährlich",
            "year": "Jährlich",
            "annual": "Jährlich"
          },
          "direction": {
            "taken": "Empfangen",
            "granted": "Gegeben",
            "received": "Kredit aufgenommen"
          }
        },
        "type": {
          "label": "Darlehenstyp",
          "tooltip": "Um welche Art von Darlehen handelt es sich? Annuität, feste Kapitalrückzahlung usw.",
          "placeholder": "Darlehenstyp auswählen",
          "error": "Darlehenstyp ist falsch."
        },
        "direction": {
          "label": "Gegeben or empfangen?",
          "tooltip": "Hast du das Darlehen gegeben oder empfangen?",
          "error": "Darlehensart ist falsch."
        },
        "loanAmount": {
          "label": "Darlehensbetrag",
          "tooltip": "Wie viel Geld hast du geliehen? Empfangene Darlehen sind negativ, gegebene Darlehen sind positiv.",
          "placeholder": "-100000",
          "error": "Bitte den Darlehensbetrag eingeben."
        },
        "interestRate": {
          "label": "Zinssatz",
          "tooltip": "Wie hoch ist der Zinssatz deines Darlehens? Änderungen wähernd der Laufzeit sind möglich.",
          "error": "Bitte den Zinssatz eingeben."
        },
        "period": {
          "label": "Ratenfrequenz",
          "tooltip": "Wie oft machst du Rückzahlungen? Änderungen wähernd der Laufzeit sind möglich.",
          "error": "Bitte den frequenz eingeben."
        },
        "bankName": {
          "label": "Bankname",
          "tooltip": "Die IBAN (Kontonummer) des Kontos (Darlehenskontos).",
          "placeholder": "DE12345678901234567890"
        },
        "iban": {
          "label": "IBAN",
          "tooltip": "Die IBAN-Nummer dieses Kontos. Beginnt mit einem Land-Kürzel z.B. >DE< für Deutschland.",
          "placeholder": "DE12345678901234567890"
        },
        "percentRepaidAnnually": {
          "label": "Tilgung",
          "tooltip": "Wie viel des Darlehens tilgst du jährlich? Änderungen wähernd der Laufzeit sind möglich.",
          "error": "Bitte die Tilgungsrate eingeben."
        },
        "contractEndDate": {
          "label": "Enddatum des Darlehens",
          "tooltip": "Wann endet der Darlehensvertrag?",
          "error": "Bitte das Enddatum des Vertrags eingeben."
        },
        "connectedDepositAccounts": {
          "label": "Verbundenes Bankkonto/Konten",
          "tooltip": "Welche(s) Bankkonto/Konten tätigt und empfängt Zahlungen für dieses Darlehen?"
        },
        "interestCalcMonthEnd": {
          "label": "Werden Zinsen am Monatsende berechnet?",
          "tooltip": "Wenn deine Bank Zinsen am Monatsende berechnet, wähle >ja<."
        },
        "connectedProjectId": {
          "label": "Verbundenes Projekt",
          "tooltip": "Welches Projekt zeigt den simulierten Tilgungsplan für dieses Darlehen?"
        }
      },
      "transaction": {
        "ownName": "Transaktion",
        "date": {
          "label": "Datum",
          "description": "Datum der Transaktion."
        },
        "otherPartyIban": {
          "label": "Darlehenkonto",
          "description": "Optional. IBAN (Kontonummer) deines Darlehenskontos."
        },
        "description": {
          "label": "Beschreibung",
          "description": "Optional. Beschreibung der Transaktion."
        },
        "quantity": {
          "label": "Kapitalanteil",
          "description": "Der Kapitalanteil dieser Rückzahlung in deiner Kontowährung."
        },
        "quantityInterest": {
          "label": "Zinsanteil",
          "description": "Der Zinsanteil dieser Rückzahlung in deiner Kontowährung."
        }
      }
    },
    "pension": {
      "account": {
        "parameters": {
          "useSpecialQuote": {
            "payoutOnlyContributionsToDate": "Rente (nur Beiträge bis heute)",
            "payoutOnlyContributionsToDateIndexed": "Rente (nur Beiträge bis heute, mit Wertentwicklung)",
            "payoutAllPlannedContributions": "Rente (alle zukünftigen Beiträge)",
            "payoutAllPlannedContributionsIndexed": "Rente (alle zukünftigen Beiträge, mit Wertentwicklung)",
            "payoutLumpSumVerrentet": "Einmalzahlung umgewandelt in Rente"
          },
          "contributionsFrequency": {
            "0": "Einmalig",
            "1": "Monatlich",
            "3": "Vierteljährlich",
            "12": "Jährlich"
          },
          "payoutsFrequency": {
            "0": "Einmalig",
            "1": "Monatlich",
            "3": "Vierteljährlich",
            "12": "Jährlich"
          },
          "frequencyUnit": {
            "0": "unbegrenzt",
            "1": "Monate",
            "12": "Jahre"
          }
        },
        "product": "Rentenprodukt",
        "connectedDepositAccounts": {
          "label": "Verbundene Bankkonten",
          "tooltip": "Welche Bankkonten senden und empfangen Zahlungen für dieses Rentenprodukt?"
        },
        "connectedDepositMode": {
          "error": "Bitte wähle hier eine Option aus."
        },
        "productPurchaseDate": {
          "label": "Kaufdatum",
          "tooltip": "Wann begann der Vertrag? Dieses Datum muss nicht sehr genau angegeben sein, wir verwenden es, um dir die Wertänderungen seit dem Kauf anzuzeigen.",
          "error": "Bitte gebe ein (ungefähres) Datum ein.",
          "errorInvalid": "Bitte gebe ein gültiges Datum ein.",
          "errorFuture": "Dieses Datum darf nicht in Zukunft liegen."
        },
        "initialQuotes": {
          "label": "Anfängliche Auszahlungsschätzungen",
          "tooltip": "Was waren die anfänglichen Auszahlungsschätzungen, die dir bei Vertragsabschluss gegeben wurden?",
          "error": "Anfängliche Auszahlungsschätzungen fehlen"
        },
        "contributionsSelfPaid": {
          "label": "Beiträge selbst gezahlt?",
          "tooltip": "Stelle dies auf JA, wenn du die Beiträge zahlst. Wenn es dein Arbeitgeber ist, stelle es auf NEIN.",
          "error": "Angabe erforderlich, ob Beiträge selbst gezahlt sind"
        },
        "contributionsAmounts": {
          "label": "Beitragshöhe",
          "placeholder": 100,
          "tooltip": "Gib die Beitragshöhe ein (wenn selbst gezahlt). Du kannst später unterschiedliche Beträge für verschiedene Zeiträume festlegen.",
          "error": "Bitte gebe die (ungefähre) Beitragshöhe ein."
        },
        "contributionsFrequency": {
          "label": "Beiträgesfrequenz",
          "tooltip": "Wie oft zahlst du Beiträge zu diesem Produkt?",
          "error": "Beitragsfrequenz nicht festgelegt"
        },
        "contributionsDeductible": {
          "label": "Sind Beiträge steuerlich absetzbar?",
          "tooltip": "Dürfen die Beiträge für dieses Produkt steuerlich angesetzt werden?",
          "error": "Bitte gebe die Information hier ein."
        },
        "contributionsIndexed": {
          "label": "Ändern sich die Beiträge über die Zeit?",
          "tooltip": "Werden die Beiträge im Zeitverlauf angepasst? Aktiviere dies, um sie mit der Inflation oder einem eigenen Zinssatz fortzuschreiben.",
          "error": "Angabe zur Beitragsentwicklung fehlt."
        },
        "payoutsPhaseStart": {
          "label": "Beginn der Auszahlungsphase",
          "tooltip": "Wann findet die erste Auszahlung statt? Wir brauchen hier lediglich ein ungefähres Datum, das später noch angepasst werden kann. Dieses Datum wird zur Darstellung der künftigen Auszahlungen verwendet.",
          "error": "Bitte gebe hier ein Datum ein."
        },
        "payoutsFrequency": {
          "label": "Auszahlungsfrequenz",
          "tooltip": "Handelt es sich um eine monatliche, vierteljährliche, jährliche oder einmalige Auszahlung?",
          "error": "Auszahlungsfrequenz nicht festgelegt"
        },
        "payoutsDuration": {
          "label": "Dauer der Auszahlungsphase",
          "tooltip": "Wie lange werden die Auszahlungen geleistet? Gebe die Anzahl der Monate an (12 für ein Jahr, 120 für zehn Jahre usw.). Bei lebenslangen Auszahlungen gebe '0' ein.",
          "error": "Dauer der Auszahlungen nicht festgelegt"
        },
        "payoutsTaxable": {
          "label": "Auszahlungen steuerpflichtig?",
          "tooltip": "Ist die Auszahlung steuerpflichtig?",
          "error": "Steuerpflicht der Auszahlung nicht angegeben"
        },
        "payoutsIndexed": {
          "label": "Auszahlungen mit Wertentwicklung?",
          "tooltip": "Wird der Auszahlungsbetrag über die Zeit angepasst? Aktiviere dies, um die Auszahlungen mit Inflation oder einem eigenen Satz zu indexieren.",
          "error": "Wachstum der Auszahlung nicht festgelegt"
        },
        "discountRateIsInflation": {
          "label": "Inflationsrate zur Wertentwicklung verwenden?",
          "tooltip": "Wähle JA, um die Inflationsrate zu nutzen, um Wachstum von Auszahlungen / Beiträgen / aktuellen Wert zu berechnen. Wähle NEIN, um einen eigenen Indexsatz anzugeben.",
          "error": "Bitte wähle, wie die Werte in diesem Konto indexiert werden sollen."
        },
        "customDiscountRate": {
          "label": "Eigener Indexsatz (%)",
          "tooltip": "Jährlicher Prozentsatz zur Indexierung von Beiträgen/Auszahlungen.",
          "error": "Bitte gib einen eigenen Indexsatz für Beiträge an.",
          "placeholder": 2
        },
        "useSpecialQuote": {
          "label": "Berechnung des Produktwerts",
          "tooltip": "Welche Rentenschätzung sollen wir verwenden, um den Barwert dieses Rentenprodukts zu berechnen?",
          "error": "Rentenschätzung nicht angegeben"
        },
        "discountRate": {
          "label": "Produktszinssatz",
          "tooltip": "Zinssatz, der verwendet wird, um den Barwert dieses Produkts sowie dessen zukünftiges Wachstum zu berechnen, falls vorhanden. Lasse ihn offen, um den in den Einstellungen angegebenen Inflationszinssatz zu verwenden.",
          "error": "Produktszinssatz nicht festgelegt",
          "placeholder": 2.3
        },
        "fxRate": {
          "label": "Heutiges Wechselkurs von {{accountCurrency}} zu {{baseCurrency}}:",
          "tooltip": "Um es einfach zu halten, wir empfehlen die Verwendung von aktuellem Wechselkurs. Du kannst gerne einen anderen Wechselkurs anwenden, den für dich langfristig besser geeignet ist.",
          "apply": "Alles automatisch zu {{baseCurrency}} umrechnen zum Kurs "
        }
      },
      "transaction": {
        "date": {
          "label": "Datum",
          "description": "An welchem Datum hat das Institut diese neue Bewertung kommuniziert?"
        },
        "currency": {
          "label": "Währung",
          "description": "Die Währung der Bewertung."
        },
        "payoutOnlyContributionsToDate": {
          "label": "Rente (nur Beiträge bis heute)",
          "description": "Höhe der Rentenzahlungen, die du erhalten würdest, falls du heute die Beiträge einstellst."
        },
        "payoutOnlyContributionsToDateIndexed": {
          "label": "Rente (nur Beiträge bis heute, mit Wertentwicklung)",
          "description": "Höhe der Rentenzahlungen, die du erhalten würdest, falls du heute die Beiträge einstellst, mit zukünftiger Wertentwicklung bereits angelegtes Kapitals."
        },
        "payoutAllPlannedContributions": {
          "label": "Rente (alle zukünftigen Beiträge)",
          "description": "Höhe der Rentenzahlungen, die du erhalten würdest, falls du die Beiträge bis der Ende der Ansparphase zahlst."
        },
        "payoutAllPlannedContributionsIndexed": {
          "label": "Rente (alle zukünftigen Beiträge, mit Wertentwicklung)",
          "description": "Höhe der Rentenzahlungen, die du erhalten würdest, falls du die Beiträge bis der Ende der Ansparphase zahlst, mit zukünftiger Wertentwicklung bereits angelegtes Kapitals."
        },
        "payoutLumpSumVerrentet": {
          "label": "Einmalzahlung in lebenslange Rente umwandeln",
          "description": "Das angesparte Kapital wird in eine lebenslange Rente umgerechnet."
        }
      }
    },
    "objectsOfValue": {
      "account": {
        "connectedDepositAccounts": {
          "label": "Verbundene Bankkonten",
          "tooltip": "Welche Bankkonten erhalten Erlöse aus den Vermögenswerten dieses Kontos?"
        },
        "name": {
          "label": "Objektname",
          "tooltip": "Unter welchem Namen soll dieses Objekt angezeigt werden?",
          "placeholder": "Mercedes 450 SEL",
          "error": "Bitte gib den Objektnamen an."
        },
        "currency": {
          "label": "Kontowährung",
          "tooltip": "Welche Währung wird für Beiträge und Auszahlungen dieses Rentenprodukts verwendet?"
        },
        "userInputPurchaseDate": {
          "label": "Kaufdatum",
          "tooltip": "Wann hast du dieses Objekt gekauft?",
          "error": "Bitte gib das Kaufdatum an."
        },
        "userInputPurchaseValueAccountCurrency": {
          "label": "Kaufpreis in {{currency}}",
          "tooltip": "Wie viel hast du für dieses Objekt bezahlt?",
          "error": "Bitte gib den Kaufpreis an."
        },
        "userInputPurchaseValueBaseCurrency": {
          "label": "Kaufpreis in {{currency}}",
          "tooltip": "Wie viel hast du für dieses Objekt bezahlt?",
          "error": "Bitte gib den Kaufpreis an."
        },
        "fxRate": {
          "label": "Wechselkurs von {{accountCurrency}} zu {{baseCurrency}} am {{date}} war",
          "tooltip": "Zu deiner Bequemlichkeit haben wir den Wechselkurs am von dir angegebenen Tag nachgeschlagen.",
          "apply": "Kaufpreis in {{baseCurrency}} berechnen"
        },
        "quantity": {
          "label": "Gekaufte Menge",
          "tooltip": "Falls hier zutreffend, wie viele Objekte hast du zuerst gekauft? Standardwert ist 1."
        }
      }
    },
    "metals": {
      "account": {
        "connectedDepositAccounts": {
          "label": "Verbundene Bankkonten",
          "tooltip": "Welche Bankkonten erhalten Erlöse aus den Vermögenswerten dieses Kontos?"
        },
        "name": {
          "label": "Kontoname",
          "tooltip": "Unter welchem Namen soll dieses Konto angezeigt werden?",
          "placeholder": "Tresor",
          "error": "Bitte gib den Kontonamen an."
        },
        "currency": {
          "label": "Kontowährung",
          "tooltip": "Welche Währung wird für Beiträge und Auszahlungen dieses Kontos verwendet?"
        }
      },
      "transaction": {
        "parameters": {
          "assetMetal": {
            "gold": "Gold",
            "silver": "Sibver",
            "platinum": "Platin",
            "palladium": "Palladium",
            "other": "anderes"
          }
        }
      }
    },
    "unlistedShares": {
      "account": {
        "connectedDepositAccounts": {
          "label": "Verbundene Bankkonto(s)",
          "tooltip": "Welche Bankkonto(s) erhalten Erlöse aus den Vermögenswerten dieses Kontos?",
          "error": "Bitte wähle eine Option aus"
        },
        "connectedDepositMode": {
          "error": "Bitte wähle eine Option aus"
        },
        "name": {
          "label": "Kontoname",
          "tooltip": "Wie heißt die Firma?",
          "placeholder": "Meine Firma",
          "error": "Bitte gebe einen Namen an"
        },
        "currency": {
          "label": "Kontowährung",
          "tooltip": "In welcher Währung sollen die Firmenbewertung in diesem Konto gehalten werden?"
        },
        "date": {
          "label": "Unternehmensgründungsdatum",
          "tooltip": "Wann wurde das Unternehmen gegründet? Ein ungefähres Datum genügt.",
          "error": "Bitte trage ein Datum ein"
        },
        "upac": {
          "label": "Startkapital",
          "tooltip": "Wie viel Startkapital hast du in das Unternehmen investiert?",
          "placeholder": 25000,
          "error": "Bitte trage einen Wert ein"
        },
        "upbc": {
          "label": "Startkapital (Basiswährung)",
          "tooltip": "Wie viel Startkapital ist das in deiner Basiswährung?",
          "placeholder": 25000,
          "error": "Bitte trage einen Wert ein"
        },
        "quantity": {
          "label": "Anzahl der Aktien",
          "tooltip": "Wie viele Aktien deiner Firma hast du gekauft? Wenn du nicht sicher bist, gebe 1 ein.",
          "placeholder": 1,
          "error": "Bitte trage einen Wert ein"
        }
      }
    },
    "crypto": {
      "account": {
        "connectedDepositAccounts": {
          "label": "Verbundene Bankkonten",
          "tooltip": "Welche Bankkonten erhalten Erlöse aus den Vermögenswerten dieses Kontos?"
        },
        "name": {
          "label": "Kontoname",
          "tooltip": "Unter welchem Namen soll dieses Konto angezeigt werden?",
          "placeholder": "Tresor",
          "error": "Bitte gib den Kontonamen an."
        },
        "brokerName": {
          "label": "Provider",
          "tooltip": "Bei welcher Börse / welchem Broker ist dieses Konto?",
          "placeholder": "Binance"
        },
        "accountNo": {
          "label": "Konto-ID",
          "tooltip": "Welche ID (Nummer / Kennung) hat dieses Konto?",
          "placeholder": "C12345678"
        }
      }
    }
  },
  "countryNames": {
    "Afghanistan": "Afghanistan",
    "Albania": "Albanien",
    "Algeria": "Algerien",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Antigua & Barabuda": "Antigua und Barbuda",
    "Argentina": "Argentinien",
    "Armenia": "Armenien",
    "Australia": "Australien",
    "Austria": "Österreich",
    "Azerbaijan": "Aserbaidschan",
    "Bahamas": "Bahamas",
    "Bahrain": "Bahrain",
    "Bangladesh": "Bangladesch",
    "Barbados": "Barbados",
    "Belarus": "Weißrussland",
    "Belgium": "Belgien",
    "Belize": "Belize",
    "Benin": "Benin",
    "Bhutan": "Bhutan",
    "Bolivia": "Bolivien",
    "Bosnia Herzegovina": "Bosnien und Herzegowina",
    "Botswana": "Botsuana",
    "Brazil": "Brasilien",
    "Brunei": "Brunei",
    "Bulgaria": "Bulgarien",
    "Burkina": "Burkina Faso",
    "Burundi": "Burundi",
    "Cambodia": "Kambodscha",
    "Cameroon": "Kamerun",
    "Canada": "Kanada",
    "Cape Verde": "Kap Verde",
    "Central African": "Zentralafrikanische Republik",
    "Chad": "Tschad",
    "Chile": "Chile",
    "China": "China",
    "Colombia": "Kolumbien",
    "Comoros": "Komoren",
    "Congo": "Republik Kongo",
    "Democratic Rep. of Congo": "Demokratische Republik Kongo",
    "Costa Rica": "Costa Rica",
    "Croatia": "Kroatien",
    "Cuba": "Kuba",
    "Cyprus": "Zypern",
    "Czechia": "Tschechien",
    "Denmark": "Dänemark",
    "Djibouti": "Dschibuti",
    "Dominica": "Dominica",
    "Dominican Republic": "Dominikanische Republik",
    "East Timor": "Osttimor",
    "Ecuador": "Ecuador",
    "Egypt": "Ägypten",
    "El Salvador": "El Salvador",
    "Equatorial Guinea": "Äquatorialguinea",
    "Eritrea": "Eritrea",
    "Estonia": "Estland",
    "Ethiopia": "Äthiopien",
    "Fiji": "Fidschi",
    "Finland": "Finnland",
    "France": "Frankreich",
    "Gabon": "Gabun",
    "Gambia": "Gambia",
    "Georgia": "Georgien",
    "Germany": "Deutschland",
    "Ghana": "Ghana",
    "Greece": "Griechenland",
    "Grenada": "Grenada",
    "Guatemala": "Guatemala",
    "Guinea": "Guinea",
    "Guinea Bissau": "Guinea-Bissau",
    "Guyana": "Guyana",
    "Haiti": "Haiti",
    "Honduras": "Honduras",
    "Hungary": "Ungarn",
    "Iceland": "Island",
    "India": "Indien",
    "Indonesia": "Indonesien",
    "Iran": "Iran",
    "Iraq": "Irak",
    "Ireland": "Irland",
    "Israel": "Israel",
    "Italy": "Italien",
    "Ivory Coast": "Elfenbeinküste",
    "Jamaica": "Jamaika",
    "Japan": "Japan",
    "Jordan": "Jordanien",
    "Kazakhstan": "Kasachstan",
    "Kenya": "Kenia",
    "Kiribati": "Kiribati",
    "Kosovo": "Kosovo",
    "Kuwait": "Kuwait",
    "Kyrgyzstan": "Kirgisistan",
    "Laos": "Laos",
    "Latvia": "Lettland",
    "Lebanon": "Libanon",
    "Lesotho": "Lesotho",
    "Liberia": "Liberia",
    "Libya": "Libyen",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Litauen",
    "Luxembourg": "Luxemburg",
    "Macedonia": "Nordmazedonien",
    "Madagascar": "Madagaskar",
    "Malawi": "Malawi",
    "Malaysia": "Malaysia",
    "Maldives": "Malediven",
    "Mali": "Mali",
    "Malta": "Malta",
    "Marshall Islands": "Marshallinseln",
    "Mauritania": "Mauretanien",
    "Mauritius": "Mauritius",
    "Mexico": "Mexiko",
    "Micronesia": "Mikronesien",
    "Moldova": "Moldawien",
    "Monaco": "Monaco",
    "Mongolia": "Mongolei",
    "Montenegro": "Montenegro",
    "Morocco": "Marokko",
    "Mozambique": "Mosambik",
    "Myanmar": "Myanmar",
    "Namibia": "Namibia",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Netherlands": "Niederlande",
    "New Zealand": "Neuseeland",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigeria",
    "North Korea": "Nordkorea",
    "Norway": "Norwegen",
    "Oman": "Oman",
    "Pakistan": "Pakistan",
    "Palau": "Palau",
    "Panama": "Panama",
    "Papua New Guinea": "Papua-Neuguinea",
    "Paraguay": "Paraguay",
    "Peru": "Peru",
    "Philippines": "Philippinen",
    "Poland": "Polen",
    "Portugal": "Portugal",
    "Qatar": "Katar",
    "Romania": "Rumänien",
    "Russian Federation": "Russische Föderation",
    "Rwanda": "Ruanda",
    "St Kitts & Nevis": "St. Kitts und Nevis",
    "St Lucia": "St. Lucia",
    "Saint Vincent & the Grenadines": "St. Vincent und die Grenadinen",
    "Samoa": "Samoa",
    "San Marino": "San Marino",
    "Sao Tome & Principe": "São Tomé und Príncipe",
    "Saudi Arabia": "Saudi-Arabien",
    "Senegal": "Senegal",
    "Serbia": "Serbien",
    "Seychelles": "Seychellen",
    "Sierra Leone": "Sierra Leone",
    "Singapore": "Singapur",
    "Slovakia": "Slowakei",
    "Slovenia": "Slowenien",
    "Solomon Islands": "Salomonen",
    "Somalia": "Somalia",
    "South Africa": "Südafrika",
    "South Korea": "Südkorea",
    "South Sudan": "Südsudan",
    "Spain": "Spanien",
    "Sri Lanka": "Sri Lanka",
    "Sudan": "Sudan",
    "Suriname": "Suriname",
    "Swaziland": "Eswatini",
    "Sweden": "Schweden",
    "Switzerland": "Schweiz",
    "Syria": "Syrien",
    "Taiwan": "Taiwan",
    "Tajikistan": "Tadschikistan",
    "Tanzania": "Tansania",
    "Thailand": "Thailand",
    "Togo": "Togo",
    "Tonga": "Tonga",
    "Trinidad & Tobago": "Trinidad und Tobago",
    "Tunisia": "Tunesien",
    "Turkey": "Türkei",
    "Turkmenistan": "Turkmenistan",
    "Tuvalu": "Tuvalu",
    "Uganda": "Uganda",
    "Ukraine": "Ukraine",
    "United Arab Emirates": "Vereinigte Arabische Emirate",
    "United Kingdom": "Vereinigtes Königreich",
    "United States": "Vereinigte Staaten von Amerika",
    "Uruguay": "Uruguay",
    "Uzbekistan": "Usbekistan",
    "Vanuatu": "Vanuatu",
    "Vatican City": "Vatikanstadt",
    "Venezuela": "Venezuela",
    "Vietnam": "Vietnam",
    "Yemen": "Jemen",
    "Zambia": "Sambia",
    "Zimbabwe": "Simbabwe"
  }
}